import BillingsOrderForwardRelatedCargoTaxiRequest from "../../../../../api/raily/billings/order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi.request";
import BillingsOrderForwardRelatedCargoTaxiParams from "./billings-order-forward-related-cargo-taxi-params";

const create = (
  params: BillingsOrderForwardRelatedCargoTaxiParams,
): BillingsOrderForwardRelatedCargoTaxiRequest => {
  return {
    forwardingId: params.forwardingUuid,
  };
};

const billingsOrderForwardRelatedCargoTaxiParamsFactory = {
  create,
};

export default billingsOrderForwardRelatedCargoTaxiParamsFactory;
